<!-- NAVBAR -->
<NavbarSection />

<!-- HERO SECTION -->
<HeroSection />

<!-- PLATFORM FEATURES SECTION -->
<PlatformFeatures />

<!-- SCORE CARD ELEMENTS SECTION -->
<ScoreCardElements />

<!-- FOOTER -->
<FooterSection />